<div
  id="holding"
  style="background-image: url('assets/img/login_background.png')"
>
  <div class="container">
    <div
      class="row justify-content-center align-items-center centerize"
      style=""
    >
      <div class="col-xl-6 col-md-8 col-sm-10">
        <div class="logo">
          <img
            src="assets/img/erp-system.png"
            srcset="
              assets/img/erp-system@2x.png 2x,
              assets/img/erp-system@3x.png 3x
            "
          />
        </div>
        <div class="form-inner">
          <div class="form-title">Şifre Hatırlatma</div>
          <div
            class="col-md-12 row"
            style="margin-top: 25px"
            *ngIf="!successStatus"
          >
            <div class="col-md-3"></div>
            <div class="col-md-6">
              <form *ngIf="token" (ngSubmit)="onSubmit()" novalidate>
                <div class="form-group row">
                  <label for="password">{{ "new_password" | translate }}</label>
                  <input
                    type="password"
                    name="password"
                    [(ngModel)]="reset.password"
                    class="form-control form-control-sm"
                    id="password"
                  />
                </div>
                <div class="form-group row">
                  <label for="rePassword">{{
                    "new_password_confirmation" | translate
                  }}</label>
                  <input
                    type="password"
                    name="repassword"
                    [(ngModel)]="reset.confirm_password"
                    class="form-control form-control-sm"
                    id="rePassword"
                  />
                </div>
                <div
                  class="alert alert-danger"
                  role="alert"
                  [hidden]="!errorStatus"
                >
                  {{ "password_reset_error" | translate }}
                </div>
                <div
                  class="alert alert-warning"
                  role="alert"
                  [hidden]="!passwordStatus"
                >
                  {{ "password_not_same" | translate }}
                </div>
                <div class="form-group row">
                  <button class="btn btn-greenish btn-block">
                    {{ "reset_password" | translate }}
                  </button>
                </div>
              </form>
            </div>
            <div class="col-md-3"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
